module.exports = __webpack_public_path__ + "static/media/search_icon.7be447e5.svg";